/** Conserva únicamente la ruta pública de la cuenta cloud. Nunca guarda claves internas
 * ni datos del proyecto. `accessKey` se mantiene vacío sólo para no duplicar tipos del cliente. */

const BASE_URL_KEY = "blackred-studio.remote.baseUrl.v1";
const ACCESS_KEY_KEY = "blackred-studio.remote.accessKey.v1";

export interface RemoteConfig {
  baseUrl: string;
  accessKey: string;
}

function readEnvDefault(name: "VITE_REMOTE_BACKEND_URL"): string {
  try {
    return String(import.meta.env?.[name] ?? "");
  } catch {
    return "";
  }
}

function readStorage(key: string): string {
  try {
    return typeof localStorage !== "undefined" ? localStorage.getItem(key) || "" : "";
  } catch {
    return "";
  }
}

function stripTrailingSlash(value: string): string {
  return value.trim().replace(/\/+$/, "");
}

export function getStoredRemoteConfig(): RemoteConfig {
  const baseUrl = readStorage(BASE_URL_KEY) || readEnvDefault("VITE_REMOTE_BACKEND_URL");
  return { baseUrl: stripTrailingSlash(baseUrl), accessKey: "" };
}

export function hasRemoteConfig(): boolean {
  return Boolean(getStoredRemoteConfig().baseUrl);
}

export function setStoredRemoteConfig(config: RemoteConfig): void {
  localStorage.setItem(BASE_URL_KEY, stripTrailingSlash(config.baseUrl));
  localStorage.removeItem(ACCESS_KEY_KEY);
}

export function clearStoredRemoteConfig(): void {
  localStorage.removeItem(BASE_URL_KEY);
  localStorage.removeItem(ACCESS_KEY_KEY);
}

/** Deriva la URL del WebSocket (`/ws`) a partir de la URL HTTP del backend remoto. */
export function wsUrlFor(baseUrl: string): string {
  return `${baseUrl.replace(/^http/, "ws")}/ws`;
}
